import { Basket } from "@/services/model/basket";

// The basket is a trial checkout if the first entry is
export const isTrialCheckout = (basket: Basket): boolean => {
  const entry = basket.entries["0"];

  return entry?.options?.[0]?.discounts?.[0]?.discountName === "Free_Trial";
};

// If balance is negative, it is the available credit, if positive it is the overall amount the user needs to pay in case of manual billing (and we ignore it)
export const getCreditAmount = (balance?: number) =>
  balance && balance < 0 ? Math.abs(balance) : 0;

/**
 * Basket discount labels sometimes include a tariff suffix from the backend
 * (e.g. "Friends with Benefits 30% FM Month"). Strip that for UI display.
 */
export const formatDiscountDisplayName = (discountName?: string) =>
  discountName?.replace(/\s+FM Month$/i, "").trim();
